import {Vtc} from '../../vtc/models/vtc';

export interface StudyProgrammeReq {
  committee?: Person[] | null;
  degree?: number | null;
  employability?: string | null;
  employabilityEn?: string | null;
  employersFeedback?: string | null;
  employersFeedbackEn?: string | null;
  faculty?: Department | null;
  formOfStudy?: StudyProgrammeReqFormOfStudy | null;
  graduateProfile?: string | null;
  graduateProfileEn?: string | null;
  guarantees?: EmployeeReq[] | null;
  idStudyProgramme?: number | null;
  languages?: LookupLanguage[] | null;
  learningObjectives?: string | null;
  learningObjectivesEn?: string | null;
  learningOutcomes?: string | null;
  learningOutcomesEn?: string | null;
  length?: number | null;
  outputs?: Vtc[] | null;
  possibleOutputs?: Vtc[] | null;
  professional?: boolean | null;
  professions?: StudyProgrammeProfession[] | null;
  receivedDegree?: string | null;
  relationToStudyField?: string | null;
  relationToStudyFieldEn?: string | null;
  studyField?: string | null;
  studyField2?: string | null;
  successfulGraduates?: string | null;
  successfulGraduatesEn?: string | null;
  title?: string | null;
  provisionClassroomsEquipment: string | null;
  provisionClassroomsEquipmentEn: string | null;
  provisionInformationProvision: string | null;
  provisionInformationProvisionEn: string | null;
  provisionDistanceEducation: string | null;
  provisionDistanceEducationEn: string | null;
  provisionElearningPortals: string | null;
  provisionElearningPortalsEn: string | null;
  provisionLearningTransitionProcedures: string | null;
  provisionLearningTransitionProceduresEn: string | null;
  provisionPartners: string | null;
  provisionPartnersEn: string | null;
  applicantAbilities: string | null;
  applicantAdmissionProcedures: string | null;
  applicantAdmissionResults: string | null;
  studyAdvisor?: EmployeeRes | null;
  studyScheduleUrl: string | null;
  studyDepartmentUrl: string | null;
  additionalInformationUrl: string | null;
  state: number | null;
}

export interface StudyProgrammeRes {
  committee?: Person[] | null;
  degree?: number | null;
  employability?: string | null;
  employabilityEn?: string | null;
  employersFeedback?: string | null;
  employersFeedbackEn?: string | null;
  faculty?: Department | null;
  formOfStudy?: StudyProgrammeResFormOfStudy | null;
  graduateProfile?: string | null;
  graduateProfileEn?: string | null;
  guarantees?: EmployeeRes[] | null;
  idStudyProgramme?: number | null;
  languages?: LookupLanguage[] | null;
  learningObjectives?: string | null;
  learningObjectivesEn?: string | null;
  learningOutcomes?: string | null;
  learningOutcomesEn?: string | null;
  length?: number | null;
  outputs?: Vtc[] | null;
  possibleOutputs?: Vtc[] | null;
  professional?: boolean | null;
  professions?: StudyProgrammeProfession[] | null;
  receivedDegree?: string | null;
  relationToStudyField?: string | null;
  relationToStudyFieldEn?: string | null;
  studyField?: string | null;
  studyField2?: string | null;
  successfulGraduates?: string | null;
  successfulGraduatesEn?: string | null;
  title?: string | null;
  titleEn?: string | null;
  provisionClassroomsEquipment?: string | null;
  provisionClassroomsEquipmentEn?: string | null;
  provisionInformationProvision?: string | null;
  provisionInformationProvisionEn?: string | null;
  provisionDistanceEducation?: string | null;
  provisionDistanceEducationEn?: string | null;
  provisionElearningPortals?: string | null;
  provisionElearningPortalsEn?: string | null;
  provisionLearningTransitionProcedures?: string | null;
  provisionLearningTransitionProceduresEn?: string | null;
  provisionPartners?: string | null;
  provisionPartnersEn?: string | null;
  applicantAbilities?: string | null;
  applicantAdmissionProcedures?: string | null;
  applicantAdmissionResults?: string | null;
  maisUrl?: string | null;
  maisUrlEn?: string | null;
  maisAcronymSk?: string | null;
  maisAcronymEn?: string | null;
  idEnglishStudyProgramme?: number | null;
  studyAdvisor?: EmployeeRes | null;
  studyScheduleUrl?: string | null;
  studyDepartmentUrl?: string | null;
  additionalInformationUrl?: string | null;
  state?: number | null;
  stateText?: string | null;
  idMinedu?: number | null;
  uipsCode?: string | null;
}

export interface StudyProgrammeProfession {
  idStudyProgrammeProfession?: number | null;
  idSustavaPovolaniEmployment?: number | null;
  idSustavaPovolaniArea?: number | null;
  idSkiscoEmployment?: number | null;
  name?: string | null;
}

export enum StudyProgrammeReqFormOfStudy {
  EXTERNAL = 'EXTERNAL',
  PRESENT = 'PRESENT',
  UNDEFINED = 'UNDEFINED',
}

export enum StudyProgrammeResFormOfStudy {
  EXTERNAL = 'EXTERNAL',
  PRESENT = 'PRESENT',
  UNDEFINED = 'UNDEFINED',
}

export interface LookupLanguage {
  identLookupLanguage?: number | null;
  name?: string | null;
  nameEn?: string | null;
}

export interface User {
  department?: Department | null;
  email?: string | null;
  employee?: Employee | null;
  faculty?: Department | null;
  fullName?: string | null;
  login?: string | null;
  uidnumber?: number | null;
}

export interface Person {
  email?: string | null;
  employmentType?: string | null;
  firstName?: string | null;
  idPerson?: number | null;
  lastName?: string | null;
  organization?: string | null;
  phone?: string | null;
  titleAfter?: string | null;
  titleBefore?: string | null;
  emailError?: boolean;
}

export interface Department {
  acronym?: string | null;
  color?: string | null;
  idDepartment?: number | null;
  name?: string | null;
  nameEn?: string | null;
  web?: string | null;
}

export interface Employee {
  email?: string | null;
  employmentType?: string | null;
  firstName?: string | null;
  fullName?: string | null;
  idDepartment?: number | null;
  idEmployee?: number | null;
  lastName?: string | null;
  login?: string | null;
  phone?: string | null;
  titleAfter?: string | null;
  titleBefore?: string | null;
  web?: string | null;
}

export interface EmployeeReq {
  email?: string | null;
  employmentType?: string | null;
  firstName?: string | null;
  idDepartment?: number | null;
  idEmployee?: number | null;
  lastName?: string | null;
  login?: string | null;
  phone?: string | null;
  titleAfter?: string | null;
  titleBefore?: string | null;
  web?: string | null;
}

export interface EmployeeRes {
  email?: string | null;
  employmentType?: string | null;
  firstName?: string | null;
  fullName?: string | null;
  idDepartment?: number | null;
  idEmployee?: number | null;
  lastName?: string | null;
  login?: string | null;
  phone?: string | null;
  titleAfter?: string | null;
  titleBefore?: string | null;
  web?: string | null;
}

export interface SpAttachment {
  id: number;
  idStudyProgramme: number;
  title: string;
  description: string;
  date: Date;
  nameOfFile: string;
  url: string | null;
}

export interface StudyProgrammeDto {
  idStudyProgramme?: number | null;
  title?: string | null;
  degree?: number | null;
  studyField?: string | null;
  studyField2?: string | null;
  guaranteesCount?: number | null;
  formOfStudy?: StudyProgrammeReqFormOfStudy | null;
  faculty?: Department | null;
  state?: number | null;
  stateText?: string | null;
}

